import React from 'react'
import moment from 'moment-timezone'
import shuffle from '../js/shuffle'

export default class Show extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    if (!this.state.show) return null
    return (
      <div className='row m-0' style={{ width: '100%' }}>
        <div className='col p-0' style={{ maxWidth: '150px' }}>{this.renderPresenterImage()}</div>
        {this.renderShow()}
      </div>
    )
  }

  renderShow () {
    if (this.state.show) {
      return (
        <div className='col-auto text-start p-0 px-3' style={{ display: 'grid', placeItems: 'center', maxWidth: '300px' }}>
          <div>
            <strong>{this.state.show.name}</strong>
            {this.renderPresenterName()}
            <br/>
            {moment(this.state.show.start_timestamp, 'YYYY-MM-DD HH:mm:ss').tz('Europe/London').format('h:mma')}
            &nbsp;-&nbsp;
            {moment(this.state.show.end_timestamp, 'YYYY-MM-DD HH:mm:ss').tz('Europe/London').format('h:mma')}
          </div>
        </div>
      )
    }
    return (
      <div className="text-start mb-3">
        <strong>Random Play</strong>
        {this.state.show.livePresenter ? <><br/><em>{this.state.show.livePresenter.name}</em></> : ''}
      </div>
    )
  }

  renderPresenterImage () {
    if (this.state.show.livePresenter) return (<img src={this.state.show.livePresenter.image} style={{ width: '100%' }} />)
    if (this.state.show.image) return (<img src={this.state.show.image} style={{ width: '100%' }} />)
    return (<img src='https://images.whitecliffsradio.co.uk/presenters/placeholder.webp' style={{ width: '100%' }} />)
  }

  renderPresenterName () {
    if (!this.state.show.livePresenter && !this.state.show.presenter_name) return
    return (
      <>
        <br/><em>{this.state.show.livePresenter ? <a href={`/presenters-and-shows/${this.state.show.livePresenter.alias}`}>{this.state.show.livePresenter.name}</a> : <a href={`/presenters-and-shows/${this.state.show.alias}`}>{this.state.show.presenter_name}</a> }</em>
      </>
    )
  }

  componentDidMount () {
    this.socket = window.io('/show', { transports: ['websocket'] })
    this.socket.on('update', update => {
      if (this.props.next) return this.setState({ show: update.next })
      return this.setState({ show: update.show })
    })
  }

  componentDidUpdate () {
    setTimeout(() => {
      shuffle.update()
    }, 100)
  }
}
